<template>
  <el-form :model="formData" status-icon :rules="rules" ref="pwdForm" label-width="150px" size="mini">
    <el-form-item label="密码" prop="oldPwd">
      <el-input type="password" v-model="formData.oldPwd" autocomplete="off" :disabled="lockOldPwd"></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="newPwd">
      <el-input type="password" v-model="formData.newPwd" autocomplete="off" ref="ensureNewPwd"></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="ensureNewPwd">
      <el-input type="password" v-model="formData.ensureNewPwd" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="新密码规则要求">
      <li>1.长度为8-16位</li>
      <li>2.须包括：字母（大小写）、数字、特殊字符（!@#$%^&*?()-_）</li>
      <li>3.不允许出现相邻位置重复（3次及以上）的数字和字母，如111、aaa</li>
      <li>4.不允许出现连续（3个及以上）的数字和字母，如123、321、abc、cba</li>
      <li>5.不允许出现关键字（不区分大小写）: daan、yunkang、yunk、ykang、yk、cts、xinguan、xg、da、an</li>
    </el-form-item>
    <!--<el-form-item>-->
    <!--<el-button type="primary" @click="saveData()">提 交</el-button>-->
    <!--&lt;!&ndash;<el-button @click="resetForm('pwdForm')">关 闭</el-button>&ndash;&gt;-->
    <!--</el-form-item>-->
  </el-form>
</template>

<script>
  import md5 from 'js-md5';
  import PasswordHelper from "../libs/PasswordHelper";
  import CryptoUtil from '../libs/CryptoUtil';
  export default {
    data() {
      let validatePassword = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.formData.newPwd !== null && this.formData.newPwd !== '') {
            this.$refs.pwdForm.validateField('newPwd');
          }
          callback();
        }
      };
      let validateNewPassword = (rule, value, callback) => {
        const isRuleNewPwd = rule.field === 'newPwd';
        const targetValue = isRuleNewPwd ? this.formData.ensureNewPwd : this.formData.newPwd;
        if (value === null || value === '') {
          callback(new Error(isRuleNewPwd ? '请输入新密码' : '请输入确认密码'));
        } else if(!PasswordHelper.isMatch(value)){
          callback(new Error('密码不符合规则要求'));
        } else if (value !== targetValue) {
          callback(new Error('新密码与确认密码不一致!'));
        } else {
          callback();
        }
        if(isRuleNewPwd && this.formData.ensureNewPwd){
          setTimeout(() => {
            this.$refs.pwdForm.validateField('ensureNewPwd');
          });

        }else if(this.formData.newPwd){
          setTimeout(() => {
            this.$refs.pwdForm.validateField('newPwd');
          });
        }
      };
      return {
        lockOldPwd: false,
        formData: {
          oldPwd: null,
          newPwd: null,
          ensureNewPwd: null,
        },
        rules: {
          oldPwd: [
            {validator: validatePassword, trigger: 'blur'}
          ],
          newPwd: [
            {validator: validateNewPassword, trigger: 'blur'}
          ],
          ensureNewPwd: [
            {validator: validateNewPassword, trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      onShow(oldPwd) {
        this.formData.oldPwd = oldPwd;
        this.formData.newPwd = null;
        this.formData.ensureNewPwd = null;
        this.lockOldPwd = this.formData.oldPwd != null;
      },
      saveData() {
        const _this = this;

        this.$refs.pwdForm.validate((valid) => {
          if (valid) {
            if(_this.formData.oldPwd === _this.formData.newPwd){
              _this.$alert("新旧密码不能一样！","提示", {
                callback: action =>{
                  _this.$refs.ensureNewPwd.focus();
                }
              });
              return false;
            }
            let param = Object.assign({}, _this.formData);
            //密码加密
            param.oldPwd = md5(this.formData.oldPwd);
            param.newPwd = md5(this.formData.newPwd);
            param.ensureNewPwd = md5(this.formData.ensureNewPwd);

            _this.$store.dispatch('loading');
            //获取一次性密钥
            _this.apiSystem.getSecretKey((data)=>{
              let secretKeyData = Object.assign({id: null, secretKey: null}, data);

              param.secretKeyId = secretKeyData.id;
              param.oldPwd = CryptoUtil.aesEncrypt(param.oldPwd, secretKeyData.secretKey);
              param.newPwd = CryptoUtil.aesEncrypt(param.newPwd, secretKeyData.secretKey);
              param.ensureNewPwd = CryptoUtil.aesEncrypt(param.ensureNewPwd, secretKeyData.secretKey);

              _this.apiSystem.updatePwd(_this.$store.state.userInfo.org_id, _this.$store.state.userInfo.id, param,
                ()=>{
                  _this.$store.dispatch('loaded');
                  //密码更改成功
                  _this.$alert("密码修改成功，需要重新登陆","提示", {
                    showClose: false,
                    callback: action =>{
                      _this.$emit('onPwdSaved');
                    }
                  });
                },
                _this.onFail);
            }, _this.onFail);


          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //失败处理方法
      onFail(error){
        const _this = this;

        _this.$notify({
          title: '错误',
          message: error.message,
          type: 'error',
          position: 'bottom-right'
        });
        _this.$store.dispatch('loaded');
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PwdUpdate.vue